import * as React from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { Field } from "@progress/kendo-react-form";

import { FormMultiSelect, FormInput } from "../FormComponents";

import NavigateToLogin from "../NavigateToLogin";

import { useGetInternalServicesQuery } from '../../store/sunbright-api';
import { useGetExternalServicesQuery } from '../../store/sunbright-api';

export interface ExamNewServicesProps {
    examType: number;
}

const ExamNewServices = ({
    examType
}: ExamNewServicesProps) => {

    const { data:dataInternal, error:errorInternal, isLoading:isLoadingInternal } = useGetInternalServicesQuery("");
    const { data:dataExternal, error:errorExternal, isLoading:isLoadingExternal } = useGetExternalServicesQuery("");

    return (
        <React.Fragment>
            {(errorInternal || errorExternal) ? (<NavigateToLogin />) : (isLoadingInternal || isLoadingExternal) ? <Loader size="large" type="converging-spinner" /> : (dataInternal && dataExternal) ? (
                <div className={"sds-questionnaire"}>
                    <fieldset
                        className={"k-form-fieldset"}
                    >
                        <legend
                            style={{ paddingTop: "24px" }}
                            className={"k-form-legend"}>
                            Services Performed
                        </legend>

                        <Field
                            label={""}
                            name={"A324"}
                            component={FormMultiSelect}
                            autoClose={false}
                            header={<span style={{ float: "right", paddingRight: "32px", fontStyle: "italic" }}>Click here when done</span>}
                            data={(examType === 0) ? dataInternal.map((item: any) => item.name) : dataExternal.map((item: any) => item.name)}
                            />
                        <Field
                            label={"Notes"}
                            name={"N324"}
                            component={FormInput}
                        />
                   </fieldset>
                </div>) : null}
        </React.Fragment >
    );
}
export default ExamNewServices;

